import React from "react"
import MapHeaderComponent from "../../../../v1/CarAdvise2/screens/Map/components/MapHeaderComponent"

const ShopFilters = ({
  activeView,
  setActiveView,
  ratingFiltersApplied,
  typeFiltersApplied,
  addorRemoveFilterItem,
  clearAllFilters,
  sortingType,
  setIsSortOpen,
  setIsFilterOpen,
  isSortOpen,
  isFilterOpen,
  updateSortingType,
  setSelectedShop
}) => {
  return (
    <div className="instacart-shop-filters">
      <MapHeaderComponent
        isCheckout
        setActiveTab={setActiveView}
        activeTab={activeView}
        ratingFiltersApplied={ratingFiltersApplied}
        typeFiltersApplied={typeFiltersApplied}
        addorRemoveFilterItem={(value, type) => addorRemoveFilterItem(value, type)}
        clearAllFilters={clearAllFilters}
        setSortingType={updateSortingType}
        sortingType={sortingType}
        setIsSortOpen={() => {
          setIsSortOpen((prev) => !prev)
          setIsFilterOpen(false)
          setSelectedShop(undefined)
        }}
        setIsFilterOpen={() => {
          setIsFilterOpen((prev) => !prev)
          setIsSortOpen(false)
          setSelectedShop(undefined)
        }}
        isSortOpen={isSortOpen}
        isFilterOpen={isFilterOpen}
        showPriceFilter={true}
        // zip={shops && shops.length > 0 ? shops[0].zip : zip}
      />
    </div>
  )
}

export default ShopFilters
